export function exportTransactionsCSVV4(send) {
  return (query, ...args) =>
    send(
      {
        path: '/v4/paymentaudit/transactions',
        pathParameters: {},
        type: 'get',
        query: query,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
